// extracted by mini-css-extract-plugin
export var body = "_ch-8";
export var button = "_ch-0";
export var closeButton = "_ch-5";
export var content = "_ch-3";
export var empty = "_ch-f";
export var grid = "_ch-c";
export var header = "_ch-4";
export var icon = "_ch-1";
export var option = "_ch-d";
export var optionSelected = "_ch-e";
export var overlay = "_ch-2";
export var searchIcon = "_ch-a";
export var searchInput = "_ch-b";
export var searchWrapper = "_ch-9";
export var title = "_ch-6";
export var visuallyHidden = "_ch-7";